export type ApprovalHierarchyMode = 'Sequential' | 'AnyOne';
export type ApproverType = 'Role' | 'User';

export interface ApprovalLevelDto {
  id: string;
  levelNo: number;
  name: string;
  approverType: ApproverType;
  approverRoleId: string | null;
  approverRoleName: string | null;
  approverUserId: string | null;
  approverUserName: string | null;
}

export interface ApprovalMatrixDto {
  id: string;
  transactionType: string;
  thresholdValue: number | null;
  hierarchyMode: ApprovalHierarchyMode;
  slaHours: number;
  autoNotify: boolean;
  isActive: boolean;
  levels: ApprovalLevelDto[];
}

export interface CreateApprovalLevelRequest {
  levelNo: number;
  name: string;
  approverType: ApproverType;
  approverRoleId: string | null;
  approverUserId: string | null;
}

export interface CreateApprovalMatrixRequest {
  transactionType: string;
  thresholdValue: number | null;
  hierarchyMode: ApprovalHierarchyMode;
  slaHours: number;
  autoNotify: boolean;
  levels: CreateApprovalLevelRequest[];
}

export interface UpdateApprovalMatrixRequest {
  thresholdValue: number | null;
  hierarchyMode: ApprovalHierarchyMode;
  slaHours: number;
  autoNotify: boolean;
  isActive: boolean;
  levels: CreateApprovalLevelRequest[];
}

export interface ApprovalActionDto {
  id: string;
  levelNo: number;
  actorUserId: string;
  actorUserName: string;
  decision: string;
  comments: string | null;
  actionDate: string;
}

export interface ApprovalInstanceDto {
  id: string;
  transactionType: string;
  transactionId: string;
  status: string;
  currentLevelNo: number;
  totalValue: number | null;
  createdDate: string;
  actions: ApprovalActionDto[];
}

export interface ActOnApprovalRequest {
  decision: 'Approved' | 'Rejected';
  comments: string | null;
}

export const TRANSACTION_TYPES = [
  'PurchaseRequest',
  'PurchaseOrder',
  'GrnDiscrepancy',
  'InventoryWriteOff',
  'StockAdjustment',
  'MaterialRequest',
  'LabelTemplate',
  'ProductionReceipt',
] as const;
